import type { RouteRecordRaw } from 'vue-router'
import NewsList from '@/views/frontDesk/news/list.vue'
import NewsDetail from '@/views/frontDesk/news/detail.vue'

// 招商活动
export const NewsRoute: Array<RouteRecordRaw> = [
  {
    path: 'newsList',
    name: 'NewsList',
    meta: {
      title: '新闻中心' 
    },
    component: NewsList
  },
  {
    path: 'newsList/newsDetail/:id',
    name: 'NewsDetail',
    meta: {
      title: '新闻详情' 
    },
    component: NewsDetail
  },
]

export default NewsRoute